import { render } from "./WelcomePanel.vue?vue&type=template&id=f613d994"
import script from "./WelcomePanel.vue?vue&type=script&lang=js"
export * from "./WelcomePanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/apriyadi/projects/investment-forecaster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__